module.exports = "/_next/static/images/794643f51460f8dfcecf88557aaf4af8-payment_slider.png";